/*
Controller: Submissions

Operations:
  getInReviewOrApprovedOrLiveSubmissionCount
  getSubmissions
  createSubmission
  getSubmission
  updateSubmission
  deleteFamilySubmission
  reTriggerValidation
*/
var Api = require('../config')
var SubmissionDef = require('../definitions/Submission')

var Submissions = (function () {
  /*
  Operation: getInReviewOrApprovedOrLiveSubmissionCount
  Count the number of submissions in either in_review or approved or live status
  Parameters:
    id: MFP Id of the foundry
  Responses:
    HTTP 200: Count of submissions in either in_review or approved or live status
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getInReviewOrApprovedOrLiveSubmissionCountSubmissions (id) {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['id'] = id
      var path = '/inReviewOrApprovedOrLiveSubmissionCount'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getSubmissions
  Get a list of submissions
  Parameters:
    sortBy: field to sort by, possible values: &#39;status&#39; , &#39;updatedAt&#39; , &#39;firstSubmittedAt&#39; , &#39;foundryName&#39; , &#39;ownerName&#39;
    sortDirection: direction to sort by, asc or desc
    filter: filter by status, possible values: &#39;in_review&#39;, &#39;in_work&#39;, &#39;in_correction&#39;, &#39;rejected&#39;, &#39;approved&#39;, &#39;live&#39;, &#39;autoApproval&#39;
    search: free search over multiple fields
    page: page number, starting with 1
    perPage: number of items per page, max 50
  Responses:
    HTTP 200: Collection of SubmissionSummary objects, last updated first
    HTTP 424: The requested resource depends on another resource that has failed.
  */
  function getSubmissionsSubmissions (sortBy, sortDirection, filter, search, page, perPage) {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['sortBy'] = sortBy
      parameters['sortDirection'] = sortDirection
      parameters['filter'] = filter
      parameters['search'] = search
      parameters['page'] = page
      parameters['perPage'] = perPage
      var path = '/submissions'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: createSubmission
  Create Submission
  Parameters:
    bodyRequest: Submission object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Submission creation failed
    HTTP 403: Operation not permitted
  */
  function createSubmissionSubmissions (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        SubmissionDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/submissions'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getSubmission
  Get Submission
  Parameters:
    submissionId: Id of the submission
    formatId: Font Format eg 7,8,11
  Responses:
    HTTP 200: Submission found
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
  */
  function getSubmissionSubmissions (submissionId, formatId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['formatId'] = formatId
      var path = '/submissions/{submissionId}'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updateSubmission
  Update an existing Submission
  Parameters:
    submissionId: Id of the submission
    bodyRequest: Submission object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Submission update failed
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
  */
  function updateSubmissionSubmissions (submissionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
        SubmissionDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/submissions/{submissionId}'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteFamilySubmission
  Delete a submission
  Parameters:
    submissionId: Id of the submission
  Responses:
    HTTP 200: Submission deleted
    HTTP 400: Submissions which are live are not eligible for deletion.
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
  */
  function deleteFamilySubmissionSubmissions (submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/submissions/{submissionId}'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'delete',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: reTriggerValidation
  Re-Trigger Binary validation
  Parameters:
    submissionId: Id of the submission
  Responses:
    HTTP 200: Valid response
  */
  function reTriggerValidationSubmissions (submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/submissions/{submissionId}/reValidate'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getInReviewOrApprovedOrLiveSubmissionCount'] = getInReviewOrApprovedOrLiveSubmissionCountSubmissions
  ret['getSubmissions'] = getSubmissionsSubmissions
  ret['createSubmission'] = createSubmissionSubmissions
  ret['getSubmission'] = getSubmissionSubmissions
  ret['updateSubmission'] = updateSubmissionSubmissions
  ret['deleteFamilySubmission'] = deleteFamilySubmissionSubmissions
  ret['reTriggerValidation'] = reTriggerValidationSubmissions
  return ret
})()

module.exports = Submissions
